import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
// import LineChartComponent from "../../../pages/internal/status/line";
import dayjs from "dayjs";
import LineChartComponent from "../../lineComponent";
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const timeZone = "America/Sao_Paulo";

export default function GraphMetricasApi(params) {
  const {
    dataGrafico = [],
    day = 30,
    handleChange = () => {},
    apiConfigs = [],
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const apiColors = apiConfigs.reduce((acc, item) => {
    acc[item.key] = item.color;
    return acc;
  }, {});

  const formatTimeValue = (value) => {
    return `${value?.toFixed(1)}s`;
  };
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;

      return (
        <Box sx={styles.conatinerCustomTooltip}>
          <Typography fontSize="14px" fontWeight={500} mb={1}>
            {`Data: ${dayjs(label).format("DD/MM/YYYY HH:mm")}`}
          </Typography>

          <Stack direction="row" alignItems="center" gap="4px">
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {apiConfigs.map((api) => {
                const value = data[api.key];

                return (
                  value && (
                    <Box key={api.key} sx={styles.containerDetails}>
                      <Box
                        sx={{
                          ...styles.boxColor,
                          bgcolor: api.color,
                        }}
                      />
                      <Typography fontSize="14px">
                        {`${api.label}: ${value}s`}
                      </Typography>
                    </Box>
                  )
                );
              })}
            </Box>
          </Stack>
        </Box>
      );
    }

    return null;
  };

  return (
    <Box>
      <Box sx={styles.containerRespostaApi}>
        <Typography sx={styles.tituloRespostaApi}>
          Tempo de Resposta API
        </Typography>
        <Box>
          {/*  <FormControl size="small" sx={styles.containerForm}>
            <Select
              value={day}
              onChange={handleChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={30}>Últimos 30 dias</MenuItem>
              <MenuItem value={7}>Últimos 7 dias</MenuItem>
              <MenuItem value={1}>Últimas 24 horas</MenuItem>
            </Select>
          </FormControl> */}
        </Box>
      </Box>
      <Box sx={styles.containerGrafico}>
        <LineChartComponent
          data={dataGrafico}
          maxTicks={10}
          xOptions={{
            dataKey: "date",
            tickFormatter: (clock) =>
              dayjs(clock).tz(timeZone).format("DD/MM HH:mm"),
          }}
          yOptions={{
            tickFormatter: formatTimeValue,
          }}
          customTooltip={CustomTooltip}
          mainLineColor={
            theme.palette.mode == "dark"
              ? theme.palette.white.main
              : theme.palette.colors.gray.darker
          }
          objectColorsLine={apiColors}
        />
      </Box>
    </Box>
  );
}
